import React, { useMemo, useCallback } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CardActionType, type CardActionItem } from './index.type'
import { Toast } from 'react-vant'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import Ripple from '@/components/Ripple'

export default React.memo(function Safety() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { state } = useLocation()

    const cardActionItems = useMemo<CardActionItem[]>(
        () => ([
            // {
            //     icon: "/icon/phone-icon.svg",
            //     title: t('手机号'),
            //     actionType: CardActionType.Phone
            // },
            {
                icon: "/icon/email-icon.svg",
                title: t('邮箱'),
                actionType: CardActionType.Email
            }
        ]),
        [t]
    )
    const handleCardAction = useCallback((_actionType: CardActionType) => {

        if (_actionType === CardActionType.Phone) {
            Toast.info(t('即将上线'))
            // navigate('/forgot-password/enter-account', {
            //     state: {
            //         accountType: CardActionType.Phone,
            //     }
            // })
        } else if (_actionType === CardActionType.Email) {
            navigate('/forgot-password/enter-account', {
                state: {
                    accountType: CardActionType.Email,
                    ...state
                }
            })
        }
    }, [navigate])


    return (
        <PageLayout tabbarPage={true}>
            <Header
                leftChildren={<Back />}
                centerChildren={<div className="text-3.75 font-medium text-black">{t("选择账号")}</div>}
            />
            <div className="px-6 py-6">
                <div className="w-full flex flex-col items-center space-y-5">
                    {cardActionItems.map(item => (
                        <Ripple key={item.title} className="rounded-3xl w-full">
                        <div
                            key={item.title}
                            className="w-full flex h-17 justify-between items-center border-[0.5px] border-solid border-[#E5E5E5] rounded-3xl px-5 cursor-pointer"
                            onClick={() => handleCardAction(item.actionType)}
                        >
                            <div className="flex items-center">
                                <div className="w-8 h-8 rounded-full flex items-center justify-center mr-1">
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <div className="flex flex-col">
                                    <div className="text-base font-500 text-black">{item.title}</div>
                                </div>
                            </div>
                            <div><img src="/icon/right-info.svg" /></div>
                        </div>
                        </Ripple>
                    ))}
                </div>
            </div>
        </PageLayout>
    )
})